import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { bonusIncludes, coreIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** Everything included — the mockup plus the full list in text. */
export function LibrarySection() {
  return <section aria-labelledby="library-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-117" data-mp="1p5jq5w3jmqs0">
      <div className="mx-auto max-w-6xl" data-id="element-118" data-mp="1agdw0mjkbqqz">
        <SectionHeading id="library-heading" eyebrow="Everything You Get" title={<>
              Here's Everything <Accent data-id="element-120" data-mp="11ijyx9dz4t2r">Waiting Inside.</Accent>
            </>} data-id="element-119" data-mp="1f8nifslgy8oi" />

        <img src={MOCKUP_URL} alt="The six core volumes of Makeup Instructor Ready with real pages on tablet, laptop and phone" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-5xl" style={{
        filter: 'drop-shadow(0 30px 36px rgba(59, 27, 87, 0.18))'
      }} data-id="element-121" data-mp="16fkafztleo19" />

        <div className="mx-auto mt-12 grid max-w-4xl gap-8 sm:grid-cols-2 sm:gap-12" data-id="element-122" data-mp="3db2js4e7ydr4">
          <div data-id="element-123" data-mp="3rakfz4tugtai">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-plum" data-id="element-124" data-mp="3r90y59sjia6m">
              6 core volumes
            </p>
            <ul className="mt-4 space-y-3" role="list" data-id="element-125" data-mp="3n6mguu4irihg">
              {coreIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-semibold leading-snug text-brand-charcoal" data-id="element-126" data-mp="2zgiaiezy54mr">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-127" data-mp="38bq1zy27fwve" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-128" data-mp="2ftu3x52qp78z">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-129" data-mp="2ftklq3nxs4du">
              Plus 5 extra bonuses
            </p>
            <ul className="mt-4 space-y-3" role="list" data-id="element-130" data-mp="et7gezmpo68d">
              {bonusIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-brand-charcoal/80" data-id="element-131" data-mp="jr8zvlo1u7kd">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-132" data-mp="ojijkjykmbe7" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 text-center" data-id="element-133" data-mp="3s10nwhf4x09v">
          <p className="font-display text-[2.2rem] font-bold leading-[1.05] text-brand-charcoal sm:text-[3rem]" data-id="element-134" data-mp="sd3c3opxh3d">
            11 Professional <Accent data-id="element-135" data-mp="5r6hzzfqre54">Digital Resources</Accent>
          </p>
          <p className="mt-3 text-[16px] text-brand-charcoal/70" data-id="element-136" data-mp="aqsw0b3e8yez">One complete makeup teaching ecosystem.</p>
        </div>
      </div>
    </section>;
}